import Lookup from 'src/componentes/select2';

const Periodicidade = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/PeriodicidadeLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default Periodicidade;
